import { render, staticRenderFns } from "./goodsSelfStatiticsForScience.vue?vue&type=template&id=da772486&scoped=true"
import script from "./goodsSelfStatiticsForScience.vue?vue&type=script&lang=js"
export * from "./goodsSelfStatiticsForScience.vue?vue&type=script&lang=js"
import style0 from "./goodsSelfStatiticsForScience.vue?vue&type=style&index=0&id=da772486&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "da772486",
  null
  
)

export default component.exports